import { uniqueId } from "@/views/zhiji/js/common/util.js";
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import i18n from "@/i18n";

export default {
    widgetName: "UpPicture",
    serverType: "upload",
    initContent() {
        return {
            uId: uniqueId(),
            updateState: "add",
            wtType: "UpPicture",
            title: "",
            isNeed: false,
            whitelist: ""
        };
    },
    checkContent(content) {
        if (!content.title) {
            throw new ParamError(i18n.t("zhiji.form.upPicture.error.title"));
        } else if (!content.tip) {
            throw new ParamError(i18n.t("zhiji.form.upPicture.error.tip"));
        }
    },
    // 后台数据转前端数据
    server2Client(content) {
        return {
            uId: uniqueId(),
            num: content.num,
            wtType: "UpPicture",
            updateState: "",
            title: content.title,
            tip: content.tip,
            isNeed: content.is_need,
            whitelist: content.whitelist
        };
    },
    // 前端数据转后台数据
    client2Server(content) {
        return {
            num: 0,
            title: content.title,
            type: "upload",
            name: "upload",
            is_need: content.isNeed,
            tip: content.tip,
            value: "",
            whitelist: content.whitelist,
            readonly: "false"
        };
    }
};
